React = require 'react'
t = require('views/internal/recup-with-helpers')('notification')
{ NotificationTestIds } = require '@trello/webdriverio-tests'

module.exports = class NotificationArchive extends React.Component

  displayName: 'NotificationArchive'

  render: t.renderable ->

    {
      archive,
      archiveHeight,
      isArchiveVisible,
      renderNotification,
      toggleArchive
    } = @props

    t.div ->
      t.button '.archive-button.quiet.unstyled-button', {
        'data-test-id': NotificationTestIds.ToggleArchive
        onClick: -> toggleArchive(false)
      }, ->
        t.icon 'down'
        if isArchiveVisible
          t.format 'hide-previous-card-activity'
        else
          t.format 'show-previous-card-activity'

      t.div
        style: { height: if isArchiveVisible && archiveHeight != 0 then archiveHeight }
        class: t.classify({
          'measuring': !archiveHeight?
          'measuring-closed': !archiveHeight? && !isArchiveVisible
          'archive': true
        }), =>
          archive.forEach(renderNotification)

          t.button '.archive-button.quiet.unstyled-button', {
            'data-test-id': NotificationTestIds.HideArchive
            onClick: -> toggleArchive(true)
          }, ->
            t.icon 'down'
            t.format 'hide'



// WEBPACK FOOTER //
// ./app/scripts/views/notification/notification-archive.coffee